module.exports = __webpack_public_path__ + "static/media/kids_06.60576e68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_06.jpg
// module id = 5862
// module chunks = 0